import React from 'react';
import Product from '../../../../../components/page/products/Product';

export default function ProductsVendor() {
	return (
		<>
			<Product />;
		</>
	);
}
